module.exports = __webpack_public_path__ + "img/dragndrop.204339.png";